import _, { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ToastComponent from '../components/toast';
import { selectToken } from '../pages/auth/authSlice';
import { type ApiError, OpenAPI } from '../services/wealthlane-hr-integration-services';
import { selectTenantId } from '../pages/configuration/customerSwitchUserSlice';
import { useNavigate } from 'react-router-dom';
import useInstance from './custom-hooks/useInstance';
import { attachDecimalConfigToRequest } from '../utils/apiDecimalConfig';

export function useWealthlaneHRIntegrationApi(): any {
  const navigate = useNavigate();
  const token = useSelector(selectToken);
  const [error, setError] = useState<ApiError | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getRoleId, getTenantById } = useInstance();

  OpenAPI.BASE = process.env.REACT_APP_WEALTHLANE_API_ENDPOINT ?? '';
  OpenAPI.TOKEN = token?.toString();
  // OpenAPI.HEADERS = {
  //   [`X-Tenant-Id`]: tenantId === null ? '' : (tenantId as string),
  //   ['X-Switch-Source-Role-Id']: window.localStorage.getItem('x-switch-role-id') ?? '',
  // };
  OpenAPI.HEADERS = {
    [`X-Tenant-Id`]: getTenantById()?.tenantId ?? '',
    ['X-Switch-Source-Role-Id']: getRoleId() ?? '',
  };

  const handleRequest = useCallback(async function <T>(request: Promise<T>) {
    setIsLoading(true);
    
    // Transfer decimal config metadata from promise to axios interceptor
    attachDecimalConfigToRequest(request);
    
    try {
      const response = await request;
      setError(undefined);
      return response;
    } catch (exception: any) {
      setError(exception);
      if (exception?.body?.error?.validationErrors as boolean) {
        const error = exception?.body?.error?.validationErrors?.map((error: any) => {
          return error.message;
        });

        if (
          error.includes('OTP is invalid') === true ||
          error.includes('Invalid Template') === true ||
          error.includes('Only excel file can be uploaded') === true
        ) {
          //
        } else {
          toast.error(<ToastComponent label='Error' message={`${String(error ?? '')}`} />, {
            toastId: 1,
            autoClose: false,
          });
        }
      } else if (
        exception?.body?.error?.message.includes('Index was outside the bounds of the array.') ===
          true ||
        exception?.body?.error?.message.includes('Only excel file can be uploaded') === true ||
        exception?.body?.error?.message.includes('Invalid Template') === true
      ) {
        //
      } else if (exception?.body?.error as boolean) {
        toast.error(
          <ToastComponent
            label='Error'
            message={`${String(exception?.body?.error?.message ?? '')}`}
          />,
          { autoClose: false }
        );
      } else if (
        exception.status === 401 ||
        (exception.status === 403 && isEmpty(exception?.body))
      ) {
        //
      } else if (!_.isEmpty(exception?.body?.error?.message)) {
        toast.error(
          <ToastComponent
            label='Error'
            message={`${String(exception?.body?.error?.message ?? '')}`}
          />,
          {
            autoClose: false,
          }
        );
      } else {
        // toast.error(
        //   <ToastComponent
        //     label='Error'
        //     message={'Server is down at the moment. Please try again after sometime.'}
        //   />,
        //   {
        //     toastId: 2,
        //     autoClose: false,
        //   }
        // );
        navigate('/server-maintainance');
      }
      throw Error(exception);
    } finally {
      setIsLoading(false);
    }
  }, []);

  function dismissError(): void {
    setError(undefined);
  }

  return { dismissError, error, isLoading, handleRequest };
}

export default useWealthlaneHRIntegrationApi;
